import styled from "@emotion/styled"
import { GetFootersQuery } from "apollo"
import Image from "next/image"
import { extractProperty } from "utils"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"
import { Mobile } from "../../common/bit/MediaQueries"
import { sharedColors } from "../../theme/colors"
import DesktopLinks from "./DesktopLinks"
import FooterIcons from "./FooterIcons"
import LowerLinks from "./LowerLinks"
import MobileLinks from "./MobileLinks"

const StyledLayout = styled.div`
  padding: 64px 16px 32px;
  gap: 32px;
  display: flex;
  flex-direction: column;
  background-color: ${sharedColors.brandDark};
  ${(p) => p.theme.breakpoints.up("md")} {
    gap: 64px;
    padding: 64px 88px;
  }
`

type UndStr = string | undefined
export default function Footer({
  footer_data,
}: {
  footer_data: GetFootersQuery
}) {
  const footer = footer_data.footer_desktop

  const megaMenu = extractProperty(footer, "megaMenu") || []
  const bottomLinks = extractProperty(footer, "bottomLinks") || []
  const social = extractProperty(footer, "social")
  const socialItemsList = extractProperty(social[0], "itemsList") || []
  const appDownloadList = extractProperty(footer, "appDownloadList") || []
  // Transformed data
  const megaMenuItems = megaMenu.map((i: any) => {
    const name = extractProperty(i, "categoryName")
    const items = extractProperty(i, "categoriesLinks") || []
    const links = items.map((it: any) => ({ name: it.name, url: it.url }))

    return { name, links }
  }) as { name: string; links: { name: string; url: string }[] }[]
  const logo = extractProperty(footer, "logo") as UndStr
  const bottomLinksItems = bottomLinks.map((bL: any) => {
    const name = bL.properties?.[0]?.propertyValue?.links?.[0]?.name
    const url = bL.properties?.[0]?.propertyValue?.links?.[0]?.url
    return { name, url }
  }) as { name: string; url: string }[]
  const socialTitle = extractProperty(social[0], "title")
  const socialItems =
    (socialItemsList?.map((i: any) => {
      const icon = extractProperty(i, "icon", true)?.[0]
      const link = extractProperty(i, "link")?.[0]?.url
      const iconHover = extractProperty(i, "iconHover")
      return { icon, link, iconHover }
    }) as {
      icon: {
        url: string
        altText: string
      }
      link: string
      iconHover: string
    }[]) || []
  const text = extractProperty(footer, "text")
  const appDownloadText = extractProperty(footer, "appDownloadText")
  const appDownloadItems = appDownloadList.map((i: any) => {
    const icon = extractProperty(i, "icon", true)?.[0]
    const link = extractProperty(i, "link")?.[0]?.url
    const iconHover = extractProperty(i, "iconHover")

    return { icon, link, iconHover }
  }) as {
    icon: { url: string; altText: string }
    link: string
    iconHover: string
  }[]

  return (
    <StyledLayout data-egged-footer>
      <Mobile>
        <Image
          width={48}
          height={48}
          src={getUmbracoMediaUrl(logo) || ""}
          alt="logo"
          style={{ margin: "auto" }}
        />
      </Mobile>
      <DesktopLinks megaMenuItems={megaMenuItems} />
      <MobileLinks megaMenuItems={megaMenuItems} />
      <FooterIcons
        logo={logo}
        socialItems={socialItems}
        socialTitle={socialTitle}
        appDownloadItems={appDownloadItems}
        appDownloadText={appDownloadText}
      />
      <LowerLinks bottomLinksItems={bottomLinksItems} text={text} />
    </StyledLayout>
  )
}
